import request from './request';
import store from '@/store';

async function get_userInfo(){
    let res = await request({
        url: "/h5/CommonParameter/userInfo",
        method: "post",
    })
    let user_info = res.data.data

    store.commit('Public/UserInfo',{data: user_info})
    
    return user_info;   
}
export default get_userInfo;